import { useCallback, useEffect, useState } from 'react';
import AdminPageHeader from '../components/AdminPageHeader';
import AdminTable from '../components/AdminTable';
import FilterButtons from '../components/FilterButtons';
import LoadStatus from '../components/LoadStatus';
import StatusBadge from '../components/StatusBadge';
import useSearchFilter from '../components/useSearchFilter';
import { getInquiries } from './inquiryApi';
import { INQUIRY_STATUS_LABELS } from './inquiryStatus';

const FILTERS = [
    { key: 'all', label: '전체' },
    { key: 'pending', label: INQUIRY_STATUS_LABELS.pending },
    { key: 'answered', label: INQUIRY_STATUS_LABELS.answered },
];

const COLUMNS = [
    { key: 'created_at', label: '작성일', className: 'nowrap muted' },
    { key: 'user', label: '작성자', className: 'nowrap', render: row => <>{row.user_name || '—'}<br /><span className="muted">{row.user_email}</span></> },
    { key: 'title', label: '제목', className: 'wide' },
    { key: 'status', label: '상태', render: row => <StatusBadge label={INQUIRY_STATUS_LABELS[row.status] || row.status} done={row.status === 'answered'} /> },
    { key: 'answered_at', label: '답변일', className: 'nowrap muted', render: row => row.answered_at || '—' },
];

// 상세 화면 경로를 만든다.
function toDetailPath(row) {
    return `/admin/inquiries/${encodeURIComponent(row.id)}`;
}

// 사용자들이 남긴 문의사항 목록 화면. 상태 필터는 주소(?status)에 남겨 상세에서 돌아와도 유지한다.
export default function InquiryListPage() {
    const [filter, setFilter] = useSearchFilter('status', FILTERS);
    const [inquiries, setInquiries] = useState(null);
    const [error, setError] = useState('');

    // 현재 필터의 문의 목록을 불러온다.
    const load = useCallback(async () => {
        setError('');
        setInquiries(null);
        try {
            setInquiries(await getInquiries(filter));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [filter]);

    useEffect(() => { load(); }, [load]);

    return (
        <>
            <AdminPageHeader title="문의사항" count={inquiries?.length} />
            <FilterButtons label="답변 상태 필터" options={FILTERS} value={filter} onChange={setFilter} />
            {inquiries ? <AdminTable columns={COLUMNS} rows={inquiries} rowKey="id" getRowLink={toDetailPath} /> : <LoadStatus error={error} onRetry={load} />}
        </>
    );
}
